import React from 'react';
import { Link } from 'react-router-dom';
import { PlusCircle, Calculator } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useUserProfile } from '../../hooks/useUserProfile';

const DashboardHeader = () => {
  const { user } = useAuth();
  const { profile, loading } = useUserProfile(user?.uid);

  const hasCredits = profile?.credits && profile.credits > 0;

  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Mes estimations</h1>
        <p className="mt-1 text-sm text-gray-500">{user?.email}</p>
      </div>
      <div className="flex space-x-4">
        <Link
          to="/quick-estimate"
          className="btn btn-secondary flex items-center whitespace-nowrap"
        >
          <Calculator className="h-4 w-4 mr-2" />
          Estimation rapide
        </Link>
        
        <Link
          to={hasCredits ? "/estimation/nouvelle" : "/credits/purchase"}
          className="btn btn-primary flex items-center whitespace-nowrap"
        >
          <PlusCircle className="h-4 w-4 mr-2" />
          {hasCredits ? "Nouvelle estimation" : "Acheter des crédits"}
        </Link>
      </div>
    </div>
  );
};

export default DashboardHeader;